export default function modal() {
  return {
    _id: false,
    type: 'puddle.modal',
    droplets: [],
    blur: false,
    pageLoad: false,
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/modal/droplet.schema.js